/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

"use strict";

import styled from "styled-components";

const Dot = styled.span`
  width: 3px;
  height: 3px;
  display: inline-block;
  background: ${props => {
    return props.color ? props.color : "#fff";
  }
};
  border-radius: 50%;
  margin: 0 5px;

  @media (max-width: 48em) {
    width: 2px;
    height: 2px;
  }
`;

export default Dot;
